'use strict';

import TrendsTemplate from './trends.html';
import TrendChart from '../trendChart/trendChart';
import './trends.scss';

export default angular
  .module('maestro.directives.components.trends', [
    TrendChart
  ])

  .directive('trends', function() {
    return {
      restrict: 'E',
      template: TrendsTemplate,
      scope: {},
      controller: function($scope,
                           $q,
                           utils,
                           EditLocationDataProvider) {
        $scope.dataProvider = EditLocationDataProvider.instance;

        angular.extend($scope, {
          onTrendClick: onTrendClick
        });

        init();

        // No code execution below this line
        // ---------------------------------

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.locationTrendsResource.init()
          ])
            .then(() => {
              //initViewModel();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });

          $scope.$watch('dataProvider.locationTrendsResource.value', () => {
            if (!$scope.dataProvider.locationTrendsResource.value) {
              return;
            }
            initViewModel();
          }, true);
        }

        function initViewModel() {
          const categories = angular.copy($scope.dataProvider.locationTrendsResource.value);
          categories.forEach((category, index) => {
            if (category.primary) {
              let zscore = parseFloat(category.trends[0].zscore);
              if (zscore == null || isNaN(zscore) || !angular.isNumber(zscore)) {
                category.noData = true;
                return;
              }
            } else {
              category.noData = true;
            }

            // Put summary category on top
            if (category.id === 'category.summary') {
              categories.splice(index, 1);
              categories.unshift(category);
            }
          });

          $scope.categories = categories;
        }

        function onTrendClick(category) {
          if ($scope.loading || !category) {
            return;
          }
          $scope.dataProvider.selectedTrendCategory = category.id;
          $scope.dataProvider.selectedHistoryTrend = category.trends[0].id;
          $scope.dataProvider.activeTab = 'trendsHistory';
        }
      }
    };
  })

  .name;
